import {
    LocationAccessRightsConfig,
} from 'app/types/accessRights.types'

const locationAccessRights: LocationAccessRightsConfig = {
    location_sales: {
        AIRLINE: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        GENERAL: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        CONSIGNEE: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        PHARMA_WAREHOUSE: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        FORWARDER: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        SERVICECENTER: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        SUPPLIER: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        ASSET_TRACKING: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        LOGGER_CENTER: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
    },
    location_airlines: {
        AIRLINE: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        GENERAL: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        CONSIGNEE: {
            read: false,
            create: true,
            edit: false,
            delete: false,
        },
        PHARMA_WAREHOUSE: {
            read: false,
            create: true,
            edit: false,
            delete: false,
        },
        FORWARDER: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        SERVICECENTER: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        SUPPLIER: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        ASSET_TRACKING: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        LOGGER_CENTER: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
    },
    location_cs: {
        AIRLINE: {
            read: false,
            create: true,
            edit: false,
            delete: false,
        },
        GENERAL: {
            read: false,
            create: true,
            edit: true,
            delete: false,
        },
        CONSIGNEE: {
            read: false,
            create: true,
            edit: true,
            delete: false,
        },
        PHARMA_WAREHOUSE: {
            read: false,
            create: true,
            edit: false,
            delete: false,
        },
        FORWARDER: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        SERVICECENTER: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        SUPPLIER: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        ASSET_TRACKING: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        LOGGER_CENTER: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
    },
    location_cs_super: {
        AIRLINE: {
            read: false,
            create: true,
            edit: true,
            delete: true,
        },
        GENERAL: {
            read: false,
            create: true,
            edit: true,
            delete: true,
        },
        CONSIGNEE: {
            read: false,
            create: true,
            edit: true,
            delete: true,
        },
        PHARMA_WAREHOUSE: {
            read: false,
            create: true,
            edit: true,
            delete: true,
        },
        FORWARDER: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        SERVICECENTER: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        SUPPLIER: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        ASSET_TRACKING: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        LOGGER_CENTER: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
    },
    location_bil: {
        AIRLINE: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        GENERAL: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        CONSIGNEE: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        PHARMA_WAREHOUSE: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        FORWARDER: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        SERVICECENTER: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        SUPPLIER: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        ASSET_TRACKING: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        LOGGER_CENTER: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
    },
    location_ops_super: {
        AIRLINE: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        GENERAL: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        CONSIGNEE: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        PHARMA_WAREHOUSE: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        FORWARDER: {
            read: false,
            create: true,
            edit: true,
            delete: true,
        },
        SERVICECENTER: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        SUPPLIER: {
            read: false,
            create: true,
            edit: true,
            delete: true,
        },
        ASSET_TRACKING: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        LOGGER_CENTER: {
            read: false,
            create: true,
            edit: true,
            delete: true,
        },
    },
    location_ops: {
        AIRLINE: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        GENERAL: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        CONSIGNEE: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        PHARMA_WAREHOUSE: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        FORWARDER: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        SERVICECENTER: {
            read: false,
            create: true,
            edit: true,
            delete: false,
        },
        SUPPLIER: {
            read: false,
            create: true,
            edit: true,
            delete: false,
        },
        ASSET_TRACKING: {
            read: false,
            create: true,
            edit: true,
            delete: false,
        },
        LOGGER_CENTER: {
            read: false,
            create: true,
            edit: true,
            delete: true,
        },
    },
    location_prd: {
        AIRLINE: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        GENERAL: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        CONSIGNEE: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        PHARMA_WAREHOUSE: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        FORWARDER: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        SERVICECENTER: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        SUPPLIER: {
            read: false,
            create: true,
            edit: true,
            delete: false,
        },
        ASSET_TRACKING: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        LOGGER_CENTER: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
    },
    location_prd_super: {
        AIRLINE: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        GENERAL: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        CONSIGNEE: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        PHARMA_WAREHOUSE: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        FORWARDER: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        SERVICECENTER: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        SUPPLIER: {
            read: false,
            create: true,
            edit: true,
            delete: true,
        },
        ASSET_TRACKING: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        LOGGER_CENTER: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
    },
    location_rnd: {
        AIRLINE: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        GENERAL: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        CONSIGNEE: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        PHARMA_WAREHOUSE: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        FORWARDER: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        SERVICECENTER: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        SUPPLIER: {
            read: false,
            create: true,
            edit: true,
            delete: false,
        },
        ASSET_TRACKING: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        LOGGER_CENTER: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
    },
    location_rnd_super: {
        AIRLINE: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        GENERAL: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        CONSIGNEE: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        PHARMA_WAREHOUSE: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        FORWARDER: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        SERVICECENTER: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        SUPPLIER: {
            read: false,
            create: true,
            edit: true,
            delete: true,
        },
        ASSET_TRACKING: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        LOGGER_CENTER: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
    },
    location_read: {
        AIRLINE: {
            read: true,
            create: false,
            edit: false,
            delete: false,
        },
        GENERAL: {
            read: true,
            create: false,
            edit: false,
            delete: false,
        },
        CONSIGNEE: {
            read: true,
            create: false,
            edit: false,
            delete: false,
        },
        PHARMA_WAREHOUSE: {
            read: true,
            create: false,
            edit: false,
            delete: false,
        },
        FORWARDER: {
            read: true,
            create: false,
            edit: false,
            delete: false,
        },
        SERVICECENTER: {
            read: true,
            create: false,
            edit: false,
            delete: false,
        },
        SUPPLIER: {
            read: true,
            create: false,
            edit: false,
            delete: false,
        },
        ASSET_TRACKING: {
            read: true,
            create: false,
            edit: false,
            delete: false,
        },
        LOGGER_CENTER: {
            read: true,
            create: false,
            edit: false,
            delete: false,
        },
    },
}

export default locationAccessRights
